<template>
  <v-card flat>
    <v-col cols="12" class="px-md-4">
      <v-card>
        <v-data-table
          :headers="headers"
          :items="customers"
          item-key="name"
          :search="search"
          :custom-filter="filterOnlyCapsText"
          class="accent"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              class="mx-4"
            ></v-text-field>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn dark x-small color="blue" depressed class="my-1 caption rounded-xl text-capitalize px-1" @click="$router.push(`/transaction_customer?username=${item.username}&source=${trxStokistFilter}`)">
              <v-icon class="caption mr-1">mdi-receipt</v-icon>
              <div class="caption-small">Detail</div>
            </v-btn>
          </template>
          <template v-slot:item.name="{ item }">
            <div class="caption-small pb-1 d-flex align-center" style="line-height: 120%;">
              {{ item.name }}
            </div>
          </template>
          <template v-slot:item.phone="{ item }">
            <div class="caption-small pb-1 d-flex align-center" style="line-height: 120%;">
              {{ item.phone }}
            </div>
          </template>
          <template v-slot:item.quantity_total="{ item }">
            <div class="caption-small pb-1 d-flex align-center" style="line-height: 120%;">
              {{ item.quantity_total }}
            </div>
          </template>
          <template v-slot:item.transaction_total="{ item }">
            <div class="caption-small pb-1 d-flex align-center" style="line-height: 120%;">
              {{ item.transaction_total | price }}
            </div>
          </template>
          <template v-slot:item.quantity_ranged="{ item }">
            <div class="caption-small pb-1 d-flex align-center" style="line-height: 120%;">
              {{ item.quantity_ranged }}
            </div>
          </template>
          <template v-slot:item.transaction_ranged="{ item }">
            <div class="caption-small pb-1 d-flex align-center" style="line-height: 120%;">
              {{ item.transaction_ranged | price}}
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-card>
</template>

<script>
export default {
  props: {
    customers: {
      type: Object,
      default: null
    },
    trxStokistFilter: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    headers () {
      return [
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Customer Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Phone',
          value: 'phone',
          sortable: true,
          align: 'left'
        },
        {
          text: 'Quantity Total (All)',
          value: 'quantity_total',
          sortable: true,
          align: 'left'
        },
        {
          text: 'Transaction Total (All)',
          value: 'transaction_total',
          sortable: true,
          align: 'left'
        },
        {
          text: 'Quantity Total (Date Range)',
          value: 'quantity_ranged',
          sortable: true,
          align: 'left'
        },
        {
          text: 'Transaction Total (Date Range)',
          value: 'transaction_ranged',
          sortable: true,
          align: 'left'
        }
      ]
    }
  },
  methods: {
    filterOnlyCapsText (value, search, item) {
      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLowerCase().indexOf(search) !== -1
      )
    }
  }
}
</script>
